export default __webpack_public_path__ + "static/media/Cardview-Active.76338aae.svg";